import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Form,
  FormGroup,
  Input,
  Button,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import { Link } from "react-router-dom";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import "./Forgot.css";

import apiRequest from '../../../api';

const ForgotPassword = () => {
  const validationSchema = Yup.object({
    email: Yup.string()
    //.email("Invalid email address")
    //.required("Email is required"),
  });

  const [successMessage, setSuccessMessage] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState(() => {
    return localStorage.getItem('Language') || 'EN';
  });
  const [languageDropdownOpen, setLanguageDropdownOpen] = useState(false);

  const toggleLanguageDropdown = () => setLanguageDropdownOpen(!languageDropdownOpen);
  useEffect(() => {
    localStorage.setItem('Language', selectedLanguage);
  }, [selectedLanguage]);
  const handleSubmit = async (value, { resetForm }) => {

    const requestBody = {
      email: value.email,
    };

    // Make the POST request
    try {
      const token = sessionStorage.getItem("jwt"); // Retrieve JWT token from localStorage
      const response = await apiRequest('/api/users/get_password', 'POST', requestBody, token);
      if(selectedLanguage === 'EN')
        setSuccessMessage("Mail was sent!");
      else
        setSuccessMessage("Mail was sent!");
      resetForm();
    } catch (error) {
      //console.error("Error creating lot:", error);
      try {
        // Parse the error message
        const errorData = JSON.parse(error.message);

        // Check if the body contains the error and starts with the desired text
        if (errorData.Body?.error?.startsWith("User with email")) {
          if (selectedLanguage === 'EN')
            setSuccessMessage("User with that email address doesn't exist");
          else
            setSuccessMessage("Korisnik sa datom email adresu ne postoji");
        } else {
          setSuccessMessage("");
        }
      } catch (parseError) {
        alert("Error: " + error);
        setSuccessMessage("");
      }

    }
  };

  return (
    <Container fluid className="login-container">
      <Row className="h-100">
        <Col md="7" className="login-image d-md-block"></Col>
        <Col md="5" className="form-with-logo d-flex align-items-start align-items-md-center justify-content-center">
          <div className="login-form text-center d-flex flex-column align-items-center">
            <div className="logo mb-5">
              <img
                src="/assets/img/Sirius_logo_blau.jpg"
                className="log-image mb-5"
                width={180}
                alt="Logo"
              />
            </div>

            <Formik
              initialValues={{
                email: "",
              }}

              onSubmit={handleSubmit}
            >
              {({ handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <FormGroup className="mb-4 position-relative">
                    <Field
                      as={Input}
                      type="email"
                      name="email"
                      placeholder="Email"
                      className="ps-5 text-start"
                    />
                    <img
                      src="assets/icons/email.svg"
                      width={25}
                      alt="email"
                      className="input-icon"
                    />
                    <label className="invalid-feedback"></label>
                  </FormGroup>
                  {successMessage && (
                    <div className="mb-3"
                      style={{
                        fontSize: "16px",
                        fontFamily: "jura-light",       // Text color
                        textAlign: "center",  // Centers the text horizontally
                      }}>
                      {successMessage}
                    </div>
                  )}
                  <Button color="primary" block type="submit">
                    {selectedLanguage === "EN" ? "Forgot Password":"Pošalji"}
                  </Button>

                  <div className="mt-3 d-flex justify-content-start">
                    <p style={{ fontFamily: "jura-light" }} >
                      {selectedLanguage === "EN" ? "Remembered your password?":"Znate šifru?"} <Link className="link_auth" to="/login">{selectedLanguage === "EN"? "Login":"Uloguj se"}</Link>
                    </p>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </Col>
      </Row>
      <Dropdown
        isOpen={languageDropdownOpen}
        toggle={toggleLanguageDropdown}
        className="position-fixed"
        style={{
          bottom: "10px",
          right: "10px",
          zIndex: 1000
        }}
      >
        <DropdownToggle
          caret
          style={{
            backgroundColor: 'transparent',
            color: 'rgba(13, 48, 114, 1)',
            border: '1px solid rgba(13, 48, 114, 1)',
            padding: '2px 15px',
            borderRadius: '5px',
            fontFamily: 'jura-light'
          }}
        >
          {selectedLanguage}
        </DropdownToggle>
        <DropdownMenu>
          <DropdownItem style={{ color: 'rgba(13, 48, 114, 1)', fontFamily: 'jura-light' }} onClick={() => setSelectedLanguage('EN')}>EN</DropdownItem>
          <DropdownItem style={{ color: 'rgba(13, 48, 114, 1)', fontFamily: 'jura-light' }} onClick={() => setSelectedLanguage('RS')}>RS</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </Container>
  );
};

export default ForgotPassword;
